"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const SongwriterCatalogHeader = () => (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("p", null, "Your catalog shows songs associated with your writer name(s) that you have added. Here, you can search to find specific songs, view details about specific song, or export your entire catalog."),
    react_1.default.createElement("br", null),
    react_1.default.createElement("p", null, "To search for specific song(s) within your catalog, select criteria from the Song Title and/or Co-Writer fields. To refine your search, click the drop-down arrow to select other search criteria. If you need more details about a song, click on the song to be taken to its Details page."),
    react_1.default.createElement("br", null),
    react_1.default.createElement("p", null,
        "To export all the songs in your catalog in one file, click the ",
        react_1.default.createElement("strong", null, "Export"),
        " button.")));
exports.default = SongwriterCatalogHeader;
